import { createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search.svg'
import _imports_1 from '@/assets/img/close.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-032ecc52")

_pushScopeId("data-v-032ecc52")
const _hoisted_1 = {
  key: 0,
  class: "chatSearchCommunities widePagePadding hasHeader",
  ref: "chatSearchContainer"
}
const _hoisted_2 = { class: "header d-flex aling-items-center justify-content-between" }
const _hoisted_3 = { class: "searchContainer" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = { class: "ms-3 me-2 d-flex align-items-center" }
const _hoisted_6 = { class: "itemImage" }
const _hoisted_7 = { class: "itemText" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!
  const _directive_userimage = _resolveDirective("userimage")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: "editor",
      tabindex: "0",
      ref: "textarea",
      "data-placeholder": _ctx.placeholder,
      contenteditable: "true",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setLocalText && _ctx.setLocalText(...args))),
      "max-height": _ctx.maxHeight,
      "min-height": _ctx.minHeight,
      onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkLetter && _ctx.checkLetter(...args)))
    }, null, 40, ["data-placeholder", "max-height", "min-height"]),
    (_ctx.showSearch)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createVNode("input", {
                type: "text",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search = $event.target.value)),
                class: "searchInput ms-2",
                ref: "searchInput"
              }, null, 544), [
                [_directive_localizedPlaceholder, { key: 'app_cercacommunityDaCollegare', value: 'Cerca community da collegare...' }]
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("img", {
                src: _imports_1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideSearch()))
              })
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.chatSearchCommunities, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "searchItem",
              key: item.identifier,
              onClick: _withModifiers(($event: any) => (_ctx.setCommunity(item)), ["stop","prevent"])
            }, [
              _withDirectives(_createVNode("div", _hoisted_6, null, 512), [
                [_directive_userimage, item.image]
              ]),
              _createVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
            ], 8, ["onClick"]))
          }), 128))
        ], 512))
      : _createCommentVNode("", true)
  ]))
})